export function isNullUndEmpty(val) {
	return val === null || val === undefined || (typeof val === "string" && val.trim() === "");
}

export const buildFilterQueryBySearchFields = (q, searchFields) => {
	return {
		...(!isNullUndEmpty(q) ? { q, search_fields: searchFields } : {}),
	};
}

export function isInArray(arr, val) {
	return arr.indexOf(val) !== -1;
}

export function isPlainObject(value) {
	return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function isArraysDiff(arr1, arr2) {
	if (!arr1 && !arr2) return true;
	if ((!arr1 && arr2) || (arr1 && !arr2)) return false;
	if (arr1.length !== arr2.length) return false;
	for (const el1 of arr1) {
		if (arr2.indexOf(el1) === -1) return false;
	}
	return true;
}

export function mapWithFilter(array, mapper) {
	return array.reduce((result, item, index) => {
		const mapped = mapper(item, index);

		if (!isNullUndEmpty(mapped)) {
			result.push(mapped);
		}

		return result;
	}, []);
}
